import styled from "styled-components";

interface StyledChipAreaProps {
  $height?: string;
}

export const StyledChipArea = styled.div<StyledChipAreaProps>`
  width: 100%;
  font: var(--label-medium-400);
  & .label-area {
    gap: 0.4rem;
    width: max-content;
    margin-bottom: 0.4rem;
  }
  & .chip-wrap {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex: 1;
    gap: 0.4rem;
    padding: 0.45rem;
    box-sizing: border-box;
    height: ${(props) => props.$height};

    border-radius: 0.4rem;
    background-color: var(--bg-gray-0);
    overflow-y: auto;
  }
`;
